import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import ChangePasswordForm from './index';
import validate from './validate';
import { submit } from '../../actions';

export default compose(
  reduxForm({
    form: 'portalChangePassword',
    validate,
  }),
  connect(null, (dispatch, ownProps) => ({
    submit: payload => dispatch(submit({
      ...payload,
      resetPasswordToken: ownProps.resetPasswordToken,
    })),
  }))
)(ChangePasswordForm);
